import { contentStructuredData } from "./seo";
import {
  canonicalPagePath,
  pageTitle,
  publicPage,
  shareImage,
  type PublicPagePath,
} from "./publicPages";
import type { PublishedPage } from "./types";

export function contentHead(page: PublishedPage | undefined) {
  if (!page) return {};
  const url = `${import.meta.env.VITE_MAITO_SITE_URL}${canonicalPagePath(page.path)}`;
  const image = new URL(shareImage(page), url).href;
  const article = "date" in page && page.date;
  return {
    meta: [
      { title: pageTitle(page.title, page.path) },
      { name: "description", content: page.description },
      { property: "og:site_name", content: "Maito" },
      { property: "og:type", content: article ? "article" : "website" },
      { property: "og:title", content: page.title },
      { property: "og:description", content: page.description },
      { property: "og:url", content: url },
      { property: "og:image", content: image },
      ...(page.image === undefined
        ? [
            { property: "og:image:width", content: "1200" },
            { property: "og:image:height", content: "630" },
            { property: "og:image:alt", content: page.title },
          ]
        : []),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: page.title },
      { name: "twitter:description", content: page.description },
      { name: "twitter:image", content: image },
    ],
    links: [
      { rel: "canonical", href: url },
      { rel: "describedby", href: `${import.meta.env.VITE_MAITO_SITE_URL}/llms.txt` },
      {
        rel: "alternate",
        type: "text/markdown",
        href: `${import.meta.env.VITE_MAITO_SITE_URL}${page.path}.md`,
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(contentStructuredData(page, url)).replace(/</g, "\\u003c"),
      },
    ],
  };
}

export function marketingHead(path: PublicPagePath) {
  return contentHead(publicPage(path));
}
